import { FormEvent } from 'react'
import { useNavigate, useParams } from 'react-router'
import { useLayoutCreate } from '../api/layouts'
import { ObjectLayoutsForm } from './object-layouts-form'

export function ObjectLayoutsCreate({ kind }: { kind?: string }) {
	const { object = kind } = useParams<{ object: string }>()
	if (!object) throw new Error('Invalid invocation')
	const navigate = useNavigate()
	const { mutate, isPending } = useLayoutCreate()

	const onSubmit = (event: FormEvent<HTMLFormElement>) => {
		const form = event.currentTarget
		event.preventDefault()

		const formData = new FormData(form)
		const data = {
			object,
			type: formData.get('type') as string,
			name: formData.get('name') as string,
			configuration: JSON.parse((formData.get('configuration') as string) || '{}'),
		}

		mutate(data, {
			onSuccess: () => {
				form.reset()
				navigate('../')
			},
		})
	}

	return <ObjectLayoutsForm object={object} onSubmit={onSubmit} isPending={isPending} />
}
